import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react';

import { showToast } from '../../utils/toast';
import { handleErrors } from '../../utils/common';

const ForgotPwd = () => {
    const [email, setEmail] = useState('');
    const formRef = useRef(null);

    const handleFormSubmit = async () => {
        const $ = window.jQuery;
        if (!$(formRef.current).valid()) return;

        try {
            const res = await axios.post(
                '/auth/forgot-password',
                { email },
                {
                    baseURL: process.env.REACT_APP_API_URL,
                    withCredentials: true,
                }
            );

            if (res.status === 200) {
                setEmail('');
                showToast('success', res.data.message, 'Success');
            }
        } catch (err) {
            handleErrors(err);
        }
    };

    useEffect(() => {
        const $ = window.jQuery;

        if (!formRef.current || !$.fn.validate) return;

        $(formRef.current).validate({
            rules: {
                email: {
                    required: true,
                    email: true
                }
            },
            messages: {
                email: {
                    required: "Please enter your email",
                    email: "Please enter a valid email address"
                }
            },
            errorClass: "invalid-feedback animated fadeInUp",
            errorElement: "div",
            errorPlacement: function (error, element) {
                $(element).closest(".form-group").append(error);
            },
            highlight: function (element) {
                $(element).addClass("is-invalid");
            },
            unhighlight: function (element) {
                $(element).removeClass("is-invalid");
            }
        });
    }, []);

    return (
        <>
            <div className="card-body">
                <div className="text-center mb-3">
                    <a href="#/"><img className="logo-auth" src="/assets/logo.png" alt="logo" /></a>
                </div>
                <h4 className="text-center mb-4">Forgot Password</h4>
                <form ref={formRef} noValidate>
                    <div className="form-group mb-3">
                        <label className="form-label">Email</label>
                        <div className="position-relative">
                            <input
                                name="email"
                                value={email}
                                type="email"
                                className="form-control"
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="text-center">
                        <button type="button" onClick={handleFormSubmit} className="btn btn-primary btn-block">Send</button>
                    </div>
                </form>
            </div>
        </>
    );
};

export default ForgotPwd;